export const ScrollChevron = {
  src: 'https://dom-content-vault-prod-cdn-assets.porter.in/Chevron_2337928d79/Chevron_2337928d79.svg',
  alt: 'arrow',
} as const;
